export default __webpack_public_path__ + "2a26a5eb1101fe97143450e3160e9074.svg";